import { MoveEventsCargoOperation } from './MoveEventsCargoOperation';

export class MoveEventsBerthCall {
    constructor(fromBerthCallId: number, toBerthCallId: number, moveEventsCargoOperationList: MoveEventsCargoOperation[]) {
        this.fromBerthCallId = fromBerthCallId;
        this.toBerthCallId = toBerthCallId;
        this.moveEventsCargoOperationList = moveEventsCargoOperationList;
    }
    fromBerthCallId: number;
    toBerthCallId: number;
    moveEventsCargoOperationList: MoveEventsCargoOperation[];
}
